import Vue from 'vue'
import 'normalize.css/normalize.css'
import App from '../App.vue'
import router from '../router/router'
import store from '../store/store'
//
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'assets/css/app.css'
import 'nprogress/nprogress.css'
import * as wei from 'util/index'
import VueJsonp from 'vue-jsonp'

Vue.use(VueJsonp)
Vue.prototype.wei = wei
Vue.config.productionTip = false
Vue.use(ElementUI)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
